import { useTranslation } from "react-i18next";
import ExpandableText from "../../../../components/app/ExpandableText";
import ScientificText from "../../../../components/ScientificText";
import type { ArticlePageArticle } from "../../hooks/useArticleData";
import { SectionTitle } from "../../../../components/ui/SectionTitle";

interface ArticleSectionLimitationsProps {
  article: ArticlePageArticle;
  isExpanded: boolean;
  setExpand: (isExpanded: boolean) => void;
}

export function ArticleSectionLimitations({
  article,
  isExpanded,
  setExpand,
}: ArticleSectionLimitationsProps) {
  const { t } = useTranslation();
  const limitations = article.limitations;

  if (!limitations) return null;

  return (
    <section data-gtm-section="limitations" data-gtm-order="7">
      <SectionTitle title={t("Limitations")} className="mb-4" />
      <ExpandableText isExpanded={isExpanded} setExpand={setExpand} lines={10}>
        <ScientificText>{limitations}</ScientificText>
      </ExpandableText>
    </section>
  );
}
